import { classNames } from "primereact/utils";

import { useFilterPanelContext } from "../filter-panel.context";
import styles from "../filter-panel.module.scss";
import { FILTERS_LABEL } from "../messages";
import type { FilterPanelCardProps } from "../types-filter-panel";

/** Moldura do painel (card de 594px do Figma). Recebe as props do `Root` e, por cima, as suas. */
export function FilterPanelCard({ children, className, style, ...rest }: FilterPanelCardProps) {
  const panel = useFilterPanelContext();

  return (
    <section
      className={classNames(styles.card, panel.classNames.card, panel.className, className)}
      style={{ ...panel.style, ...style }}
      aria-label={FILTERS_LABEL}
      data-testid={panel.partTestId("panel")}
      {...panel.rest}
      {...rest}
    >
      {children}
    </section>
  );
}
FilterPanelCard.displayName = "FilterPanel.Card";
